import { fullDate } from '@app/utils';
import { getDaysArray } from '@data/api/utils/helpers';
import { ReportEntity, WorkDayUserEntity } from './types';

export const transformUserReportsData = (
  reports: ReportEntity[],
  { from, to }: { from?: string; to?: string },
  hideWeekend: boolean,
): WorkDayUserEntity[] => {
  const daysArray = getDaysArray(hideWeekend, from, to);
  const daysReports = daysArray.map(day => {
    const foundReports = reports.filter(report => fullDate(report.workday) === day);
    return {
      date: day,
      reports: foundReports,
      totalMinutes: foundReports.reduce((sum, report) => sum + report.minutes, 0),
    };
  });
  return daysReports;
};

/** Each day narrowed to the chosen products, its total along with it. No products chosen keeps every report. */
export const onlyProducts = (days: WorkDayUserEntity[], productIds: string[]): WorkDayUserEntity[] => {
  if (!productIds.length) return days;
  const chosen = new Set(productIds);
  return days.map(day => {
    const reports = day.reports.filter(report => chosen.has(report.involvement?.product?.id));
    return {
      ...day,
      reports,
      totalMinutes: reports.reduce((sum, report) => sum + report.minutes, 0),
      productsFiltered: true,
    };
  });
};
